// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppRouter_segment__SaCCn {
  margin: 0 !important;
  border-top: none !important;
  height: 100vh;
  padding: 0 !important;
  overflow: hidden;
  background: white;
}

.AppRouter_darkSegment__g4n3x {
  margin: 0 !important;
  border-top: none !important;
  height: 100vh;
  padding: 0 !important;
  overflow: hidden;
  background: rgb(18, 18, 18);
}`, "",{"version":3,"sources":["webpack://./src/AppRouter.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,2BAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,oBAAA;EACA,2BAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,2BAAA;AACF","sourcesContent":[".segment {\n  margin: 0 !important;\n  border-top: none !important;\n  height: 100vh;\n  padding: 0 !important;\n  overflow: hidden;\n  background: white;\n}\n\n.darkSegment {\n  margin: 0 !important;\n  border-top: none !important;\n  height: 100vh;\n  padding: 0 !important;\n  overflow: hidden;\n  background: rgba(18, 18, 18);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"segment": `AppRouter_segment__SaCCn`,
	"darkSegment": `AppRouter_darkSegment__g4n3x`
};
export default ___CSS_LOADER_EXPORT___;
